import { Component, OnInit } from '@angular/core';
import { MdDialog } from '@angular/material';
import { DocumentContract } from '../../_models/document-contract';
import { D4signAccountBalanceDTO } from '../../_models/_dto/d4sign-account-balance.dto';
import { ContractDocumentService } from '../../_services/contract-document.service';

@Component({
	selector: 'contracts-balance',
	styles: [require('./contracts-balance.component.css')],
	template: require('./contracts-balance.component.html')
})

export class ContractsBalanceComponent implements OnInit {

	accountBalance: D4signAccountBalanceDTO;

	documents: DocumentContract[] = [];
	selectedDocuments: DocumentContract[] = [];

	constructor(
		public dialog: MdDialog,
		private contractDocumentService: ContractDocumentService
	) { }

	async ngOnInit() {
		this.findAccountBalance();
	}

	findAccountBalance() {
		this.contractDocumentService.getAccountBalance().subscribe(
			(data) => {
				this.accountBalance = data;
			},
			(error) => {
				console.log(error);
			}
		);
	}
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/dashboard/contracts-balance/contracts-balance.component.ts